import { render, staticRenderFns } from "./PolicyDetails.vue?vue&type=template&id=2e75c50c&scoped=true"
import script from "./PolicyDetails.vue?vue&type=script&lang=js"
export * from "./PolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetails.vue?vue&type=style&index=0&id=2e75c50c&prod&scoped=true&lang=css"
import style1 from "./PolicyDetails.vue?vue&type=style&index=1&id=2e75c50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e75c50c",
  null
  
)

export default component.exports